import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import SearchBar from '../datatable/SearchBar';
import RelationDataTable from '../../components/datatable/RelationDataTable';
import Thumbnail from '../../components/thumbnail/Thumbnail';

import { getColumnStyle, COLUMN_STYLE } from '../../components/datatable/util';

import {
  addLightingSetToZone,
  editLightingSetInZone,
  listLightingSetInZone,
  removeLightingSetFromZone,
} from '../../redux/zone/zone_lt_set_actions';

import { defaultRejectHandler, stringifyErrorMessage } from '../../utils/utility';

import { searchLightingSetByText } from '../../redux/luminaire/lightingset_actions';


export class LightingSetDataTable extends React.Component {
  constructor(props) {
    super(props);
    const { zoneId, t } = props;

    this.search = {
      pageSize: this.DEFAULT_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    this.state = {
      categoryOption: 'all',
      isShowCreateModal: false,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isDuplicateModal: false,
    };

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);

    this.columns = [
      {
        Header: '',
        accessor: 'lighting_set.thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'lighting_set.name',
        ...textColumn,
        entity: {
          list: (text, page) => searchLightingSetByText(text, page, zoneId)
            .then(response => response.data.map(({ name, id }) => ({ label: name, value: String(id) }))),
        },
      },
      {
        Header: () => <b>{t('power (W)')}</b>,
        accessor: 'lighting_set.power_required',
        ...coeColumn,
        width: 140,
      },
      {
        Header: () => <b>{t('quantity')}</b>,
        accessor: 'quantity',
        ...textColumn,
        width: 80,
        attr: {
          type: 'number',
          isRequired: true,
          props: { min: 1 },
        },
      },
    ];

    this.state = {};
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }

    this.search.filtered = filter;

    this.props.listLtSet(
      this.search.pageSize,
      this.search.page,
      this.search.sorted,
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category],
    );

    this.setState({ categoryOption: category });
  }

  render() {
    const { categoryOption } = this.state;

    const {
      ltSetList,
      filteredCount,
      isLoading,
      addLightingSetToZone,
      editLightingSetInZone,
      removeLightingSetFromZone,
      isLightingSetAdding,
      isLightingSetEditing,
      isLightingSetRemoving,
      errorMessage,
      t,
    } = this.props;

    const relationship = {
      create: ({ entityId, quantity }) => addLightingSetToZone(entityId, quantity),
      edit: ({ id, quantity }) => editLightingSetInZone(id, quantity),
      delete: id => removeLightingSetFromZone(id),
      isCreating: isLightingSetAdding,
      isEditing: isLightingSetEditing,
      isDeleting: isLightingSetRemoving,
    };

    return (
      <div style={{ backgroundColor: 'white' }}>
        <SearchBar onSearch={text => this.updateSortFilter(text, null, this.state.categoryOption)} />
        <RelationDataTable
          columns={this.columns}
          data={ltSetList}
          errorMessage={stringifyErrorMessage(errorMessage)}
          relationship={relationship}
          relationshipNameAccessor={item => item.lighting_set.name}
          onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
          filteredCount={filteredCount}
          isLoading={isLoading}
          onFetchData={state => this.updateSortFilter(this.search.filtered, state, this.state.categoryOption)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ltSetList: state.zoneLightingSet.orderedIds.map(id => state.zoneLightingSet.objects[id]),
  isLoading: state.zoneLightingSet.isLoading,
  isLightingSetAdding: state.zoneLightingSet.isCreating,
  isLightingSetEditing: state.zoneLightingSet.isEditing,
  isLightingSetRemoving: state.zoneLightingSet.isDeleting,
  errorMessage: state.zoneLightingSet.errorMessage,
});

const mapDispatchToProps = (dispatch, ownedProps) => ({
  listLtSet: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(dispatch(listLightingSetInZone(pageSize, page, sorted, filtered, isPublic, ownedProps.zoneId))),
  addLightingSetToZone: (ahuId, quantity) =>
    defaultRejectHandler(dispatch(addLightingSetToZone(ahuId, ownedProps.zoneId, quantity))),
  editLightingSetInZone: (id, quantity) =>
    defaultRejectHandler(dispatch(editLightingSetInZone(id, quantity))),
  removeLightingSetFromZone: id =>
    defaultRejectHandler(dispatch(removeLightingSetFromZone(id))),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(LightingSetDataTable),
);



// WEBPACK FOOTER //
// ./src/components/zone/LightingSetDataTable.js